import { ProgressSpinner } from 'primereact/progressspinner'
import { useTranslation } from 'react-i18next'

// local imports
import logo from 'assets/images/koc-logo.svg'
import { INotRatedReservations } from 'types/RateType'
import useGetNotRatedReservations from './use-get-not-rated-reservations'
import NoContent from 'components/ui/NoContent'
import ListView from './ListView'
import { ListHeader, ListViewContainer, LoaderWrapper } from './styled'

export default function NotRatedReservationList() {
  const { t } = useTranslation()
  const { list, loading, getReservationList } = useGetNotRatedReservations()

  /* Loading & No Data Status Control */
  if (loading) return showLoading()
  if (list?.length < 1) return <NoContent message={t('evaluation.evaluation-not-found')} />

  return (
    <div className="px-2 py-4">
      <ListHeader>{t('evaluation.evaluation-header')}</ListHeader>
      <ListViewContainer>
        {list?.map((li: INotRatedReservations) => (
          <ListView listItem={li} getReservationList={getReservationList} />
        ))}
      </ListViewContainer>
    </div>
  )
}

const showLoading = () => {
  return (
    <LoaderWrapper className="loading">
      <ProgressSpinner style={{ position: 'absolute', width: '140px', zIndex: 1102 }} />
      <img
        alt="loading-list"
        style={{ position: 'absolute', width: '65px', height: '65px', zIndex: 1102 }}
        src={logo}
      />
    </LoaderWrapper>
  )
}
